import axios from 'axios'


// 添加访问记录
export function addVisitRecord(data) {
  return axios.post('/wechat/hx/visitRecord', data);
}

// 获取访问记录
export function getVisitRecord() {
  return axios.get('/wechat/hx/getVisitRecord');
}